export const DASHBOARD_DRAG_APPEND_TARGET_ID = '__dashboard_drag_append__';

/**
 * 落点语义：插入到返回 id 对应项之前；末项下半区 / 追加区 → append。
 * 若下半区算出的「下一项」就是自己（已在悬停项正下方），改为插到悬停项前——
 * 瀑布流高卡片（如经营看板）大半是下半区，否则统计卡片拖上去会空操作。
 */
export const resolveInsertBeforeTargetId = (orderedIds, sourceId, hoveredId, clientY, hoveredRect) => {
	if (!hoveredId || !hoveredRect || hoveredId === sourceId) return null;

	const index = orderedIds.indexOf(hoveredId);
	if (index < 0) return null;

	const insertBefore = clientY < hoveredRect.top + hoveredRect.height / 2;
	if (insertBefore) return hoveredId;

	const nextId = orderedIds[index + 1];
	if (!nextId) return DASHBOARD_DRAG_APPEND_TARGET_ID;
	if (nextId === sourceId) return hoveredId;
	return nextId;
};

export const isDashboardDragAppendTarget = (targetId) => targetId === DASHBOARD_DRAG_APPEND_TARGET_ID;
